<script>
import ProSelect from '$common/ProSelect'
import ProInput from '$common/ProInput'

export default {
  name: 'ClassEditor',
  components: {
    'pro-select': ProSelect,
    'pro-input': ProInput,
  },
  props: ['options'],
  data() {
    return {
      saving: false,
      timeTypes: ['start_time', 'end_time'],
      fullTimes: {},
      previousTimes: {},
      classToEdit: {},
      statuses: ['OPEN', 'FULL', 'CANCELLED'],
    }
  },
  computed: {
    locations () {
      return this.options.locations
    },
    classGroups () {
      return this.options.classGroups
    },
    statusOptions () {
      return this.statuses.map(status => ({value: status, name: status,}))
    },
  },
  methods: {
    getTimeOptions (timeType) {
      return {
        title: {start_time: 'Start time', end_time: 'End time'}[timeType],
        onFocus: () => {
          this.$modals.show({
            name: 'clock-picker',
            onSave: (time) => {
              this.fullTimes[timeType] = time
              this.classToEdit[timeType] = time.formatted
              this.$modals.hide('clock-picker')
            },
          })
        },
        zIndex: 2,
      }
    },
    readyToAddClass () {
      const cte = this.classToEdit
      return cte.location_id && cte.class_group_id && cte.start_time && cte.end_time && cte.date && !this.saving
    },
    readyTimes () { //saves previous times in case of no edit
      this.timeTypes.forEach(type => {
        this.previousTimes[type] = this.classToEdit[type]
        const [hours, minutes] = this.options.classToEdit[type].split(':').map(Number)
        this.classToEdit[type] = `${(hours % 12) || 12}:${this.$ensure2(minutes)} ${hours >= 12 ? 'PM' : 'AM'}`
      })
    },
    async onSaveClass () {
      if (!this.readyToAddClass) return this.$toast('Include start and end times.')
      this.saving = true

      const classToEditFormatted = {
        ...this.classToEdit,
      }
      //puts in actual times instead of display times
      this.timeTypes.forEach(timeType => {
        const ft = this.fullTimes[timeType] // if there is no edit on a time, it uses the previous time
        classToEditFormatted[timeType] = ft ? `${ft.hours}:${this.$ensure2(ft.minutes)}` : this.previousTimes[timeType]
      })

      const classesRef = this.$firestore.collection('classes')

      try {
        await classesRef.doc(classToEditFormatted.id).set(classToEditFormatted)
        this.$toast('Save successful')
      } catch (e) {
        console.log(e)
        this.$toast('Error occurred')
      }

      this.saving = false
      this.$modals.hide('class-editor')
    },
    async onDelete () {
      if (!confirm(`Click 'OK' to confirm the deletion of this class.`)) return

      this.$modals.hide('class-editor')
      try {
        this.$firestore.collection('classes').doc(this.classToEdit.id).delete()
        this.$toast('Deleted class')
      } catch (e) {
        console.error(e)
        this.$toast('Failed to delete class.')
      }
    },
  },
  mounted () {
    this.classToEdit = this.$clone(this.options.classToEdit)
    this.readyTimes()
  },
}
</script>

<template lang="pug">
  .class-editor-main.modal-main
    .class-editor-container.modal-container
      .title
        .copy Edit Class
        .icon-holder(
          @click='onDelete'
        )
          i.material-icons delete
      .content
        .pro-form
          .form-row.short
            pro-select(
              :options='locations'
              v-model='classToEdit.location_id'
              title='Location'
            )
          .form-row.short
            pro-select(
              :options='classGroups'
              v-model='classToEdit.class_group_id'
              title='Class group'
            )
          .form-row.short(
            v-for=`(time, idx) in ['start_time', 'end_time']`
            :key='idx'
          )
            pro-input(
              v-model='classToEdit[time]'
              :options=`getTimeOptions(time)`
            )
          .form-row.short
            pro-select(
              :options='statusOptions'
              v-model='classToEdit.status'
              title='Status'
            )
      .action
        .button.cancel(
          @click=`$modals.hide('class-editor')`
        ) Cancel
        span
        .button(
          @click='onSaveClass'
        ) {{saving ? 'Saving...' : 'Save'}}
</template>

<style lang="sass" scoped>
  @import '$styles/form.sass'
  .class-editor-main.modal-main
    .class-editor-container.modal-container
      .title
        display: grid
        grid-template-columns: max-content auto
        align-items: center
        padding: 10px 15px
        .icon-holder
          display: grid
          justify-items: end
          cursor: pointer
          i
            transition: all .25s
            padding: 5px
            &:hover
              background-color: #333
              border-radius: 25px
      .content
        padding-top: 24px
      .action
        grid-template-columns: 1fr 1fr 1fr
</style>